var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmmaSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4834 32.9528L15.4915 36.8215L7.62818 36.8215L7.61165 36.8215C6.90435 36.8216 6.24701 37.0889 5.74169 37.59C5.23669 38.0908 4.95001 38.7591 4.95001 39.4614L4.95001 42.6904C4.95001 44.1441 6.12944 45.3303 7.59512 45.3303L15.4924 45.3303L27.4852 49.0478L27.5904 49.0804L27.5457 48.9797L25.5485 44.4861L24.5727 37.6323L26.546 33.0197L26.5907 32.9151L26.4834 32.9528Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 32.9528L64.5085 36.8215L72.3718 36.8215L72.3883 36.8215C73.0957 36.8215 73.753 37.0889 74.2583 37.59C74.7633 38.0908 75.05 38.7591 75.05 39.4614L75.05 42.6904C75.05 44.1441 73.8706 45.3303 72.4049 45.3303L64.5076 45.3303L52.5148 49.0478L52.4096 49.0804L52.4543 48.9797L54.4508 44.4877L54.9494 37.6317L53.4524 33.0154L53.4213 32.9193L53.5166 32.9528Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8266 39.8209L49 36L49 45L60.786 41.7362C61.7422 41.4714 61.7707 40.1259 60.8266 39.8209Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1734 39.8209L31 36L31 45L19.214 41.7362C18.2578 41.4714 18.2293 40.1259 19.1734 39.8209Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0507 29.9993H29.5543V50.3245H50.0507V29.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4463 40.1619C24.4463 48.5493 31.3182 55.3633 39.7525 55.3901V55.4066H39.8025C48.2762 55.4066 55.1587 48.5822 55.1587 40.1783C55.1587 31.7744 48.2762 24.95 39.8025 24.95C31.3289 24.95 24.4463 31.7579 24.4463 40.1619ZM25.3563 40.1783C25.3563 32.2729 31.8295 25.8532 39.8025 25.8532C47.759 25.8532 54.2488 32.273 54.2488 40.1783C54.2488 48.0837 47.7755 54.5034 39.8025 54.5034C31.8295 54.5034 25.3563 48.0837 25.3563 40.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7878 25.7905L25.2946 40.1626L39.7878 54.5346L54.2809 40.1626L39.7878 25.7905Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmmaSplit);
export default __webpack_public_path__ + "static/media/EmmaSplit.44e22e362a891f67863b666e295f2f7a.svg";
export { ForwardRef as ReactComponent };